import { Navigate } from 'react-router-dom';
import { useState } from 'react';

import classes from './WorksContent.module.css';
import { scrollIntoPosition } from '../helpers/helpers';

import Video from '../frames/Video';
import NumberedItem from '../layouts/NumberedItem';
import ButtonText from '../buttons/ButtonText';

import videoWebm from './../../assets/vid/works/works-rentz.webm';

const Rentz = props => {
  // Navigation
  const [toBrandPage, setBrandPage] = useState(false);

  if (toBrandPage === true) return <Navigate to="/works/rentz" />;

  const navigateHandler = () => {
    setBrandPage(true);
    scrollIntoPosition('top');
  };

  return (
    <div className={`${classes.container} ${props.class}`}>
      <NumberedItem number="2" title="Rentz" class={classes.heading} />
      <Video webm={videoWebm} class={classes.video} />

      <div className={classes.contentBox}>
        <h2 className={`${classes.contentHeading} heading-2`}>
          A motorcycle rental website
        </h2>

        <ul className={`${classes.contentBullet} heading-3`}>
          <li className={classes.bullet}>Form validation</li>
          <li className={classes.bullet}>Disable selected items</li>
          <li className={classes.bullet}>Multi-pages routing</li>
          <li className={classes.bullet}>Direction aware carousel</li>
          <li className={classes.bullet}>Neon styling</li>
        </ul>

        <ButtonText
          text="Discover Rentz"
          class={classes.button}
          onClick={navigateHandler}
        />
      </div>
    </div>
  );
};

export default Rentz;
